var _path, _path2, _ellipse, _ellipse2, _ellipse3, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 96,
    viewBox: "0 0 114 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8118 47.2682L40.6079 35.4501C41.713 35.0119 42.6882 34.2993 43.4416 33.3798L50.2467 25.0745C54.1569 20.3023 61.8806 22.5552 62.6119 28.6813L65.9805 56.9003C66.6811 62.7692 60.2422 66.8111 55.2613 63.629L44.6403 56.8437C43.1328 55.8806 41.3138 55.5312 39.5568 55.8672L14.6991 60.6213C10.4046 61.4426 6.41992 58.1613 6.40227 53.7891C6.39068 50.9153 8.14044 48.3277 10.8118 47.2682Z",
    fill: "#0A8899"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3067 73.5696L17.9798 59.924C17.4093 57.584 18.9774 55.261 21.361 54.9151C23.8241 54.5578 26.0312 56.4678 26.0312 58.9567V73.0019C26.0312 74.3254 24.9584 75.3983 23.6349 75.3983C22.5301 75.3983 21.5684 74.6429 21.3067 73.5696Z",
    fill: "#0A8899"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.3936,
    cy: 28.3228,
    rx: 18.3936,
    ry: 28.3228,
    transform: "matrix(-1 0 0 1 79.4937 14.4709)",
    fill: "#0A8899"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.1147,
    cy: 24.7418,
    rx: 16.1147,
    ry: 24.7418,
    transform: "matrix(-1 0 0 1 77.2148 17.5801)",
    fill: "url(#paint0_linear_28740_739)",
    stroke: "#077382",
    strokeWidth: 2
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.23215,
    cy: 6.34822,
    rx: 4.23215,
    ry: 6.34822,
    transform: "matrix(-1 0 0 1 12.105 49.3049)",
    fill: "#0A8899"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.751 36.0553L87.0481 9.60308L95.0842 20.047L52.751 36.0553Z",
    fill: "url(#paint1_linear_28740_739)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4073 42.1L111.96 30.0547L103.739 45.3045L51.4073 42.1Z",
    fill: "url(#paint2_linear_28740_739)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8725 51.2153L97.4728 53.6569L89.4967 65.7022L52.8725 51.2153Z",
    fill: "url(#paint3_linear_28740_739)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28740_739",
    x1: -5.01215e-7,
    y1: 20.9388,
    x2: 29.2995,
    y2: 24.8454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005966"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003B43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28740_739",
    x1: 90.7988,
    y1: 16.3814,
    x2: 52.2211,
    y2: 35.9144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.56185,
    stopColor: "#00E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28740_739",
    x1: 84.4508,
    y1: 34.2868,
    x2: 50.9191,
    y2: 42.4256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28740_739",
    x1: 82.4974,
    y1: 55.4474,
    x2: 47.6636,
    y2: 51.2153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E1FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotify);
export default __webpack_public_path__ + "static/media/notify.d33b038ae9e01c9ba7af8c9fdfb3169f.svg";
export { ForwardRef as ReactComponent };